import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HomeService() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // زبان از سگمنت اول URL
  const seg = location.pathname.split("/")[1];
  const lang = seg === "fa" || seg === "en" ? seg : "en";

  // انیمیشن
  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const withLang = (to) => `/${lang}${to.startsWith("/") ? to : `/${to}`}`;
  const handleServiceClick = (section) => {
    navigate(withLang(`/service?section=${section}`));
  };

  const txpItems = t("homeService.txp.items", { returnObjects: true });
  const abbItems = t("homeService.abb.items", { returnObjects: true });

  return (
    <>
      <section
        className="col-xs-12 pl-0 pr-0 pt-5 pb-5"
        dir={lang === "en" ? "ltr" : "rtl"}
      >
        <h2 className="service-home text-blue1 pb-2">
          {t("homeService.txp.title")}
        </h2>

        <div className="container noPadding">
          <div className="col-xs-12 col-md-12 parent">
            <div className="col-xs-12 col-md-8 pr-0 pl-5 paddingmob child">
              <div
                className="boxone"
                style={{ cursor: "pointer" }}
                onClick={() => handleServiceClick("txp")}
              >
                <ul>
                  {Array.isArray(txpItems) &&
                    txpItems.map((text, idx) => (
                      <li
                        key={idx}
                        className={`fade-in from-right delay-${Math.min(
                          idx + 1,
                          4
                        )}`}
                      >
                        {text}
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            <div className="col-xs-12 col-md-4 pl-0 pr-5 paddingmob child">
              <div className="img-simens fade-in from-bottom delay-4">
                <img
                  src="/assets/sim.png"
                  alt={t("homeService.txp.imageAlt")}
                  className="img-responsive"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="col-xs-12 pl-0 pr-0 pt-5 pb-5"
        style={{ background: "#fff" }}
        dir={lang === "en" ? "ltr" : "rtl"}
      >
        <h2 className="service-home2 text-blue1 pb-2">
          {t("homeService.abb.title")}
        </h2>

        <div className="container noPadding">
          <div className="col-xs-12 col-md-12 parent">
            <div className="col-xs-12 col-md-4 pr-0 pl-5 paddingmob child">
              <div className="img-abb fade-in from-right delay-4">
                <img
                  src="/assets/abb.jpg"
                  alt={t("homeService.abb.imageAlt")}
                  className="img-responsive"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="col-xs-12 col-md-8 pl-0 pr-5 paddingmob child">
              <div
                className="boxone fade-in from-bottom delay-2"
                style={{ cursor: "pointer" }}
                onClick={() => handleServiceClick("abb")}
              >
                <ul>
                  {Array.isArray(abbItems) &&
                    abbItems.map((text, idx) => (
                      <li
                        key={idx}
                        className={`fade-in from-bottom delay-${Math.min(
                          idx + 2,
                          4
                        )}`}
                      >
                        {text}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
